// src/pages/auth/RedefinirSenha.tsx
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiPost } from '../../services/api';
import { showAlert } from '../../contexts/DialogContext';
import { resolveAuthError } from '../../services/authError';
import AnimatedCanvas from '../../components/common/AnimatedCanvas';
import '../../pages/auth/Login.css';
import logoBluelt from '../../assets/images/logoBluelt.png';
import { logger } from '@/utils/logger';

const RedefinirSenha = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  useEffect(() => {
    document.title = 'Bluelt | Redefinir Senha';
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!email) {
      await showAlert('Por favor, insira um e-mail válido.', { variant: 'warning' });
      return;
    }

    setIsLoading(true);

    try {
      const response = await apiPost('/v1/password-reset/request', { email });
      await showAlert(response.data?.message || 'E-mail de recuperação enviado com sucesso!', { variant: 'success' });
      setEmail('');
      navigate('/login');
    } catch (error) {
      logger.error('Erro ao solicitar redefinição de senha:', error);
      const { message, variant } = resolveAuthError(error, 'Erro ao solicitar redefinição de senha. Tente novamente mais tarde.');
      await showAlert(message, { variant });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AnimatedCanvas />
      <div className="auth-container">
        <form id="login-form" onSubmit={handleSubmit} noValidate>
          <img src={logoBluelt} alt="Logo Bluelt" className="logo" />
          <h3>Redefinir Senha</h3>
          <div className="form-group">
            <input
              type="email"
              id="recovery-email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          {!isLoading ? (
            <button type="submit" className="btn-submit">Enviar</button>
          ) : (
            <button type="button" className="btn-clone" disabled>
              <div className="spinner"></div>
            </button>
          )}
          <div className="area-suporte">
            <a
              className="forgot-link"
              href="https://bluelt.atlassian.net/servicedesk/customer/portal/1/user/login?destination=portal%2F1"
              target="_blank"
              rel="noopener noreferrer"
            >
              Precisa de ajuda?
            </a>
            <a className="forgot-link" href="/login">Voltar para o login</a>
          </div>
        </form>
      </div>
    </>
  );
};

export default RedefinirSenha;